export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";